<template>
  <div class="round-details-header-parts">
    <img class="round-details-header-parts-bg" :src="raceData.imgPath" alt="" />

    <div class="round-details-header-parts-data">
      <p class="round-details-header-parts-name" v-html="raceData.courseName" />
      <p class="round-details-header-parts-round">
        <span class="round-details-header-parts-round__label">RD.</span>
        <span class="round-details-header-parts-round__num" v-text="raceData.round" />
      </p>
    </div>
    <figure class="round-details-header-parts-course">
      <img :src="raceData.courseImgPath" :alt="raceData.courseName" />
    </figure>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'

export type RoundDetailsHeaderDataType = {
  round: number
  imgPath: string
  courseName: string
  courseImgPath: string
}

/**
 * Standings: レース詳細 ヘッダーパーツ
 */
export default defineComponent({
  name: 'RoundDetailsHeaderParts',
  props: {
    raceData: {
      type: Object as PropType<RoundDetailsHeaderDataType>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.round-details-header-parts {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: min(#{convertPXtoVW(16), 16px}) min(#{convertPXtoVW(20), 20px})
    min(#{convertPXtoVW(12), 12px});

  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-position: right bottom;
    object-fit: cover;
    z-index: 0;
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    display: block;
    content: '';
    opacity: 1;
    background: rgba(0, 0, 0, 20%);
  }

  &-data {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-items: flex-start;
    gap: min(#{convertPXtoVW(8)}, 8px);
    width: calc(100% - min(#{convertPXtoVW(88), 88px}));
    color: $white;
  }

  &-name {
    display: block;
    max-width: 190px;
    height: min(#{convertPXtoVW(36)}, 36px);
    font-family: $fontHeading;
    font-style: normal;
    font-weight: 600;
    font-size: min(#{convertPXtoVW(16), 16px});
    text-transform: uppercase;
    line-height: 1.12;
    letter-spacing: 0.04em;
  }

  &-round {
    font-weight: 600;

    &__label {
      font-size: min(#{convertPXtoVW(14), 14px});
      line-height: 1.43;
      letter-spacing: 0.02em;
    }

    &__num {
      font-family: $fontHeading;
      font-size: min(#{convertPXtoVW(42), 42px});
      line-height: 1;
      letter-spacing: 0.04em;
    }
  }

  &-course {
    position: relative;
    z-index: 2;
    width: min(#{convertPXtoVW(80), 80px});

    img {
      width: 100%;
    }
  }
}
</style>
